import { Environment, baseEnv } from './base-environment';

export const environment: Environment = {
  ...baseEnv,
  production: false,
  development: true,
  api: {
    avs: 'https://dev-avsapi.provadis.de/api',
  },
};
